<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<!-- All buttons on main-menu trigger Angular routing DOM redirects -->
<mat-toolbar color="primary" class="menubar">
  <button mat-button [routerLink]="''">
    <h2><span class=Title><b>{{title}}</b></span></h2>
  </button>
  <button mat-button [routerLink]="'routes'">
    <mat-icon>navigation</mat-icon>
    <span>Routing</span>
  </button>
  <button mat-button [routerLink]="'heatmap'">
    <mat-icon>map</mat-icon>
    <span>Heat Map</span>
  </button>
  <button mat-button [routerLink]="'bins'">
    <mat-icon>delete</mat-icon>
    <span>Bins</span>
  </button>
  <button mat-button [routerLink]="'fleet'">
    <mat-icon>local_shipping</mat-icon>
    <span>Fleet</span>
  </button>

  <button mat-mini-fab 
  color="primary"
  style="position: absolute; top: 5px; right: 5px;"
  (click)="showCredits()">
    <mat-icon>help_outline</mat-icon>
  </button>
</mat-toolbar>
